import React from 'react';

const NotFound = function() {
    return (<p>Oops! I'm not sure where to find that.</p>);
}

export default NotFound;